import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Result, Spin } from 'antd';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

/**
 * Composant de validation du claim après clic sur le lien email
 * Route : /register/validate-claim/:token
 */
const ClaimValidation = () => {
  const navigate = useNavigate();
  const { token } = useParams();
  const [isLoading, setIsLoading] = useState(true);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(null);

  // useRef pour éviter les appels multiples
  const requestSentRef = useRef(false);

  useEffect(() => {
    const validateClaim = async () => {
      // Vérifier si la requête a déjà été envoyée
      if (requestSentRef.current) {
        return;
      }

      requestSentRef.current = true;

      if (!token) {
        setError('Token manquant dans l\'URL');
        setIsLoading(false);
        return;
      }

      try {
        const response = await axios.get(`${BACKEND_URL}/api/register/validate-claim/${token}`);

        if (response.data.message === 'ok') {
          setSuccess(true);
          // Rediriger vers la page de connexion après 3 secondes
          setTimeout(() => {
            navigate('/', {
              state: {
                message: 'Inscription validée avec succès ! Vous pouvez maintenant vous connecter.'
              }
            });
          }, 3000);
        }
      } catch (err) {
        console.error('Erreur validation claim:', err);

        if (err.response && err.response.data) {
          const errorMsg = err.response.data.data?.[0] || err.response.data.message || 'Erreur lors de la validation';
          setError(errorMsg);
        } else {
          setError('Erreur de connexion au serveur');
        }
      } finally {
        setIsLoading(false);
      }
    };

    validateClaim();

    // Cleanup
    return () => {
      requestSentRef.current = true;
    };
  }, [token, navigate]);

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '100vh',
      padding: '20px'
    }}>
      <div style={{ maxWidth: '600px', width: '100%' }}>
        <Spin spinning={isLoading} fullscreen />

        {!isLoading && success && (
          <Result
            status="success"
            title="Inscription validée avec succès !"
            subTitle="Votre entreprise adhérente a été rattachée à votre compte. Vous allez être redirigé vers la page de connexion dans quelques secondes."
          />
        )}

        {!isLoading && error && (
          <Result
            status="error"
            title="Erreur de validation"
            subTitle={error}
            extra={
              <button
                onClick={() => navigate('/')}
                style={{
                  padding: '10px 20px',
                  backgroundColor: '#1890ff',
                  color: 'white',
                  border: 'none',
                  borderRadius: '4px',
                  cursor: 'pointer'
                }}
              >
                Retour à l'accueil
              </button>
            }
          />
        )}
      </div>
    </div>
  );
};

export default ClaimValidation;
